import actionTypes from 'SRC/modules/redux/actionTypes'

export const setPaidAds = (ads) => ({
  type: actionTypes.SET_PAID_ADS,
  payload: ads
})
